import * as hide from './hide/hide'
import * as grouping from './grouping/grouping'
import * as order from './order/order'
import * as verticalScaleAndSize from './verticalScaleAndSize/verticalScaleAndSize'
import * as horizontalScaleAndSize from './horizontalScaleAndSize/horizontalScaleAndSize'
import * as textScale from './textScale/textScale'
import * as alignComponent from './alignment/alignment'
import * as cancelRotation from './rotate/rotate'

export {hide, grouping, order, horizontalScaleAndSize, verticalScaleAndSize, textScale, alignComponent, cancelRotation}
